import type { CreateWebhookEndpointInput, WebhookEndpoint, WebhookEvent } from '@emailforge/schemas';

import { apiSlice } from '@/features/api/apiSlice';

export type WebhookDeliveryRow = {
  id: string;
  eventType: WebhookEvent;
  statusCode: number | null;
  attempts: number;
  deliveredAt: string | null;
  errorMessage: string | null;
  createdAt: string;
};

export const webhooksApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    listWebhooks: b.query<WebhookEndpoint[], void>({
      query: () => '/webhooks',
      providesTags: ['Webhook'],
    }),
    createWebhook: b.mutation<{ id: string; secret: string }, CreateWebhookEndpointInput>({
      query: (body) => ({ url: '/webhooks', method: 'POST', body }),
      invalidatesTags: ['Webhook'],
    }),
    rotateSecret: b.mutation<{ id: string; secret: string }, string>({
      query: (id) => ({ url: `/webhooks/${id}/rotate`, method: 'POST' }),
      invalidatesTags: ['Webhook'],
    }),
    testWebhook: b.mutation<{ ok: boolean }, string>({
      query: (id) => ({ url: `/webhooks/${id}/test`, method: 'POST' }),
    }),
    deleteWebhook: b.mutation<void, string>({
      query: (id) => ({ url: `/webhooks/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Webhook'],
    }),
    listDeliveries: b.query<WebhookDeliveryRow[], string>({
      query: (id) => `/webhooks/${id}/deliveries`,
    }),
  }),
});

export const {
  useListWebhooksQuery,
  useCreateWebhookMutation,
  useRotateSecretMutation,
  useTestWebhookMutation,
  useDeleteWebhookMutation,
  useListDeliveriesQuery,
} = webhooksApi;
